import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import CreativeTable from './CreativeTable';

export const CreativeAdGroupAddCreativesModal = ({
  visible,
  setVisible,
  selectedAdGroup,
  orgMedias,
  setCreativeKeys,
  updateAdGroup,
}) => {
  // Initialize with the creatives already in this ad group
  const [ids, setIds] = useState(() => {
    if (selectedAdGroup?.medias) {
      return selectedAdGroup.medias.map(media => media.id);
    }
    return [];
  });

  // Update ids when modal opens with a new ad group
  React.useEffect(() => {
    if (visible && selectedAdGroup?.medias) {
      setIds(selectedAdGroup.medias.map(media => media.id));
    }
  }, [visible, selectedAdGroup]);

  const handleCancel = () => {
    setIds([]);
    setCreativeKeys([]);
    setVisible(false);
  };

  const handleOk = async () => {
    await updateAdGroup({
      adGroup: {
        ...selectedAdGroup,
        medias: ids,
      },
      type: 'connect',
    });
    setVisible(false);
    setIds([]);
    setCreativeKeys([]);
  };
  return (
    <>
      <Modal
        title={`${selectedAdGroup.name} - Add Creatives`}
        visible={visible}
        width={800}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button type="primary" onClick={handleOk}>
            Submit
          </Button>,
        ]}
      >
        <CreativeTable
          orgMedias={orgMedias}
          setCreativeKeys={setCreativeKeys}
          setIds={setIds}
          ids={ids}
        />
      </Modal>
    </>
  );
};
